import React from "react";

/**
 * The top bar. 56px, quiet ground (SHELL.md).
 *
 *   Left  = CONTEXT — the area crumb plus the live object: the offer/campaign
 *           switcher on Workstation, the assistant or project on EA, a plain
 *           area label on Brain, Operations and Settings.
 *   Right = area-appropriate controls.
 *
 * The live object is a SLOT, not a component. The Workstation session owns what
 * goes in it (A2 — one Workstation whose content follows the selected offer or
 * campaign, so the switcher belongs here rather than inside the page), and the
 * shell only guarantees the position. Same for the right-hand controls.
 *
 * SEARCH AND NOTIFICATIONS ARE GONE, NOT HIDDEN
 * =============================================
 * Both shipped as disabled controls wired to nothing, on the reasoning that a
 * placed-but-empty control was more honest than an invented one. In production
 * that reasoning inverts: a permanently greyed-out button is not read as "not
 * built yet", it is read as "broken", and it invites a click on every visit
 * that has never once done anything.
 *
 * There is no endpoint behind either and no Founder ruling on what they should
 * do, so the honest bar is the one without them. Founder ruling on this change
 * is DELETE. Restoring them is a revert of one commit if the ruling changes.
 */
export default function AppBar({ areaLabel, object, actions }) {
  return (
    <header className="appbar">
      <div className="appbar-left">
        <span className="appbar-crumb">{areaLabel}</span>
        {object ? <div className="appbar-object">{object}</div> : null}
      </div>

      <div className="appbar-right">{actions}</div>
    </header>
  );
}
